<template>
  <v-flex
    v-if="!loading"
    xs12
    md8
    offset-md2
    align-self-center
    justify-center
  >
    <v-card flat light>
      <RoleTabs
        :role="role"
        v-model="currentTab"
        @delete="deleteRole"
        @edit="editRole"
      />

      <v-tabs-items v-model="currentTab" light touchless>
        <v-tab-item value="role">
          <RoleDetails :role="role"/>
        </v-tab-item>
        <v-tab-item value="role-permission">
          <RolePermissions :role="role"/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-flex>
  <Loader v-else/>
</template>

<script>
  import { mapActions } from 'vuex';

  import { rolesService } from '../../utils/services/roles.service';

  import RoleTabs from '../../components/app/Roles/RoleTabs';
  import RoleDetails from '../../components/app/Roles/RoleDetails';
  import RolePermissions from '../../components/app/Roles/RolePermissions';

  import RoleModal from '../../components/modals/Roles/RoleModal.vue';

  import Loader from '../../components/shared/Loader';

  export default {
    name: 'RoleShow',
    components: {
        Loader,
        RoleTabs,
        RoleDetails,
        RolePermissions,
    },
    props: {
      id: [String, Number],
      tab: [String, Number],
    },
    data() {
      return {
        loading: false,
        role: {},
        currentTab: this.tab,
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      async fetchRoles(id) {
        return rolesService.get(id)
        .then(response => {
          this.role = response.data.data;
        })
        .catch(error => {
          this.handleError(error, this.errors);
        });
      },

      async deleteRole() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return rolesService.remove(this.id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.$router.push(`/${this.routeName.ROLE}`);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
      async editRole() {
          this.showModal({
              component: RoleModal,
               data: {
                  stored: {
                    id: this.id,
                  },
              },
              options: {
                title: this.$t('ZONE'),
                onSave: (
                  form,
                  error,
                ) => rolesService.save(form)
                .then(() => {
                  this.hideModal({});
                  this.showToast({ type: 'success', message: this.$t('SAVED') });
                })
                .catch(error => {
                  this.handleError(error, this.errors);
                })
                .finally(() => {
                  this.loading = false;
                }),
              },
            });
      },

    },
    async created() {
      this.loading = true;
      await this.fetchRoles(this.id);
      this.loading = false;
    },
  };
</script>
